// components/RequireSuperAdmin.js
import React from "react";
import { Navigate } from "react-router-dom";

export default function RequireSuperAdmin({ children }) {
    const token = localStorage.getItem("neev-auth-token");
    const role = localStorage.getItem("neev-auth-role");
    if (!token || (role !== "superadmin" && role !== "admin")) {
      return <Navigate to="/admin-login" replace />;
    }
    return children;
}
